module.exports = __webpack_public_path__ + "img/15.6e26e092.png";